// import { Inject } from 'vue-di-container';
import { Inject } from 'vue-di-container';
import { Component, ProvideReactive, Vue } from 'vue-property-decorator';
import WithRender from './app.html';
// components
import CurrentUserAccessor from '@/services/currentUserAccessor';
import Breadcrumb from '@/components/Breadcrumb/breadcrumb';
import UserModel from '@/models/user';

@WithRender
@Component({
  components: {
    Breadcrumb,
  },
  diProvide: [
    CurrentUserAccessor,
  ],
})
export default class App extends Vue {
    @Inject(CurrentUserAccessor) public currentUserAccessor!: CurrentUserAccessor;

    @ProvideReactive()
    public userInfo: UserModel = {} as UserModel;

    @ProvideReactive()
    public isUserInfoLoading = true;

    public async mounted() {
      try {
        this.userInfo = await this.currentUserAccessor.GetCurrentUser();
      } finally {
        this.isUserInfoLoading = false;
      }
    }
}
